import React from 'react';
import { Link } from 'react-router-dom';
import { useFeatureFlags } from '../context/FeatureFlagsContext';
import './Header.css';
import config from '../config';

const Header = ({ isLoggedIn, onLogout, isAdmin, onToggleSidebar }) => {
  const { flags } = useFeatureFlags();

  return (
    <header className="header">
          {onToggleSidebar && (
            <button className="hamburger-btn" onClick={onToggleSidebar} aria-label="Toggle menu">
              <i className="fas fa-bars"></i>
            </button>
          )}
      <div className="logo">
        <div className="logo-icon">🦋</div>
        <h1>{config.APP_NAME}</h1>
      </div>

      <nav className="nav-links">
        {isLoggedIn ? (
          <>
            {isAdmin && <span className="admin-badge">Admin</span>}
            <button className="logout-btn" onClick={onLogout}>
              Logout
            </button>
          </>
        ) : (
          <>
            <Link to="/">Home</Link>
            <Link to="/login">Login</Link>
            {flags.marketing_video_enabled && (
              <Link to="/demo" className="nav-demo-link">▶ Watch Demo</Link>
            )}
          </>
        )}
      </nav>
    </header>
  );
};

export default Header;
